import alignment from './alignment';
import code from './code/';
import emphasize from './emphasize';
import headings from './headings';
import link from './links';
import lists from './lists';
import paragraphs from './paragraphs';
import quotes from './quotes';
import color from './color';
export default {
    paragraphs: paragraphs,
    headings: headings,
    link: link,
    lists: lists,
    quotes: quotes,
    code: code,
    emphasize: emphasize,
    alignment: alignment,
    color : color
};
//# sourceMappingURL=index.js.map